import { useEffect } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { SecureRoute } from '@okta/okta-react';

export function TrackRoute({ children, secure, ...props }: RouteProps & { secure?: boolean }): JSX.Element {
    return (
        secure
            ? <SecureRoute {...props}>{children}</SecureRoute>
            : <Route {...props}>{children}</Route>
    );
}
